exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}body,html{margin:0;padding:0}body{margin:0 auto}input::-ms-clear{display:none}.kv-site{overflow:hidden;padding:env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)}@supports (padding:0){.kv-site{padding-left:max(0,env(safe-area-inset-left));padding-right:max(0,env(safe-area-inset-right))}}", ""]);

// exports
